import React, { Fragment, useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt, faListAlt,faPlus } from "@fortawesome/free-solid-svg-icons";
import AlertModal from '../../../../shared/components/Modal';
import Tooltip from '@material-ui/core/Tooltip';
import history from '../../../../history';
import ArticlesModal from './ArticlesModal';
import ArticlesInventoryAPI from '../api/ArticlesInventoryAPI';

const ArticlesListActions = ({ data, Callback, inventoryTypes,articlesInvoiceProcess,preAddItemArticle }) => {
    const [openModal, setOpenModal] = React.useState(false);
    const [showDeleteModal, setDeleteModal] = React.useState(false);
    const [successModal, setSuccessModal] = React.useState(false);
    const [errorModal, setErrorModal] = React.useState(false);

    useEffect(() => {
    }, []);

    const openUpdateModal = () => {
        setOpenModal(true);
    }

    const closeModalDelete = () => {
        setDeleteModal(false);
    }

    const deleteArticle = async () => {
        setDeleteModal(false);
        let dataDelete = {
            id_inventario : data.data.original.id_inventario
        }
        await ArticlesInventoryAPI.eliminarArticulosInventario(dataDelete).then(() => {
            setSuccessModal(true);
        }).catch(err => {
            setErrorModal(true);
        });
    }

    const addArticleManualInvoice = () => {
        if(typeof preAddItemArticle != 'undefined') {
            preAddItemArticle(data.data.original);
        }
    }

    const onOkModal = () => {
        setSuccessModal(false);
        Callback();
    }

    return (<Fragment>
        <td role="cell">
            {
                articlesInvoiceProcess == undefined ? <> <Tooltip title="Editar Articulo">
                <IconButton style={{ fontSize: '15px' }} onClick={() => openUpdateModal()}>
                    <FontAwesomeIcon icon={faEdit} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Eliminar Articulo">
                <IconButton style={{ fontSize: '15px' }} onClick={() => setDeleteModal(true)}>
                    <FontAwesomeIcon icon={faTrashAlt} />
                </IconButton>
            </Tooltip>
                </> :  <Tooltip title="Agregar Articulo a la Factura">
                <IconButton style={{ fontSize: '15px' }} onClick={() => addArticleManualInvoice()}>
                    <FontAwesomeIcon icon={faPlus} />
                </IconButton>
            </Tooltip>
            }
           
        </td>

        <ArticlesModal
            article={data.data.original}
            closeModal={() => setOpenModal(false)}
            opened={openModal}
            inventoryTypes={inventoryTypes}
            Callback={() => Callback()}
        />

        <AlertModal
            color="warning"
            title="Esta seguro de eliminar este articulo?"
            modal={showDeleteModal}
            onOk={() => deleteArticle()}
            toggle={() => closeModalDelete()}
        />

        <AlertModal
            color="success"
            title="Articulo eliminado correctamente"
            modal={successModal}
            onOk={() => onOkModal()}
            toggle={() => setSuccessModal(false)}
        />

        <AlertModal
            color="danger"
            title="Ha ocurrido un error al eliminar el Articulo"
            modal={errorModal}
            onOk={() => setErrorModal(false)}
            toggle={() => setErrorModal(false)}
        />
    </Fragment>)
}

export default ArticlesListActions;